import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { SebbiaLockup } from "@/components/brand/SebbiaLogo";
import { Sheet, SheetContent, SheetDescription, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { Boton } from "./Boton";
import { NAV_LINKS } from "./content";

// Navbar sticky: transparente sobre el hero, sólida con sombra apenas la página se mueve (el cambio
// dice "ya no estás arriba"). Sólo 4 enlaces + Ingresar + un primario: el recorrido es corto.
export const LandingNav = () => {
  const [conScroll, setConScroll] = useState(false);
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    const onScroll = () => setConScroll(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "sticky top-0 z-40 border-b transition-[background-color,border-color,box-shadow] duration-300",
        conScroll
          ? "border-slate-200/70 bg-white/90 shadow-sm backdrop-blur-md"
          : "border-transparent bg-transparent",
      )}
      data-testid="landing-nav"
    >
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6" aria-label="Principal">
        <a href="#inicio" className="rounded-xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-200" aria-label="SEBBIA, ir al inicio">
          <SebbiaLockup size="sm" wordClassName="text-slate-900" as="span" />
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-600 transition-colors duration-200 hover:text-indigo-700 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-200"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-2 md:flex">
          <Boton href="/login" variante="fantasma" data-testid="landing-ingresar">
            Ingresar
          </Boton>
          <Boton href="#demo" data-testid="landing-nav-demo">
            Agenda una demo
          </Boton>
        </div>

        <Sheet open={abierto} onOpenChange={setAbierto}>
          <SheetTrigger asChild>
            <button
              type="button"
              className="inline-flex h-11 w-11 items-center justify-center rounded-xl text-slate-700 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-200 md:hidden"
              aria-label="Abrir menú"
              data-testid="landing-menu-movil"
            >
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[85vw] max-w-sm bg-white p-6">
            <SheetTitle className="sr-only">Menú</SheetTitle>
            <SheetDescription className="sr-only">Secciones de la página y acceso a SEBBIA</SheetDescription>
            <SebbiaLockup size="sm" wordClassName="text-slate-900" as="span" />
            <ul className="mt-8 space-y-1">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setAbierto(false)}
                    className="block rounded-xl px-3 py-3 text-base font-semibold text-slate-700 hover:bg-indigo-50/60 hover:text-indigo-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-8 space-y-3 border-t border-slate-100 pt-6">
              <Boton href="#demo" tamano="lg" className="w-full" onClick={() => setAbierto(false)}>
                Agenda una demo
              </Boton>
              <Boton href="/login" variante="secundario" tamano="lg" className="w-full">
                Ingresar
              </Boton>
            </div>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
};
